import { redirectRoute } from '../helpers';
import { DisruptionAlertsPages } from '../../constants/AppConstants';

export default {
    path: '/timetable-change',

    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/disruptionAlert/landing/Handler').default);
        }, 'disruption-alerts-handler');
    },

    indexRoute: redirectRoute(null, DisruptionAlertsPages.DELETE),

    getChildRoutes(location, cb) {
        require.ensure([], (require) => {
            cb(null, [
                require('./Delete').default,
            ].filter(Boolean));
        }, 'timetable-change-routes');
    },
};
